import {
  Tooltip,
  UI_BODY_BOLD_SM,
  UI_BODY_SEMIBOLD_SM,
  UI_BODY_SM,
  colors2,
  TagClearV2,
  icons
} from "oolib";
import React from "react";
import {
  StyledFilterAccordionHeader,
  StyledFilterAccordionTitleWrapper,
  StyledSelectedValuesWrapper,
} from "../styled";
import { NumberRangeCompactInput } from "@/components/inputs/NumberRangeSlider/NumberRangeCompactInput";
import ReactJson from "react-json-view";

const { CaretRight, LinkSimple } = icons

export const AccordionHeader = ({
  title,
  value,
  expand,
  onToggle,
  onChange,
  id,
  filterConfig,
  lightboxConfig,
  optionHeaderRef,
  debug
}) => {
  // For number range, value is an object {min, max} or {exact} not an array
  const isNumberRange = lightboxConfig.comp === "NumberRangeType";
  const hasValue = isNumberRange
    ? (value && typeof value === 'object' && !Array.isArray(value) &&
        (value.min !== undefined || value.max !== undefined || value.exact !== undefined))
    : value?.length > 0;

  const TITLE_TYPO = hasValue ? UI_BODY_SEMIBOLD_SM : UI_BODY_SM;

  const readableDate = date => new Date(date).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' })

  return (
    <StyledFilterAccordionHeader
      expand={expand}
      value={value}
      onClick={onToggle}
      style={{  }}
      ref={optionHeaderRef}
    >
      <StyledFilterAccordionTitleWrapper>
     
        <div style={{
          display: 'flex', 
          alignItems: 'center', 
          gap: '0.4rem',
          minWidth: 0, // Allows flex item to shrink below content size
          flex: 1 // Takes available space
        }}>
          {["nestedRollupTagType", "rollupValuePathType"].includes(
            filterConfig.target.filterType
          ) && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: '0.4rem',
                backgroundColor: colors2.grey10,
                borderRadius: "0.4rem",
                flexShrink: 0, // Prevents icon from shrinking
              }}
            >
              {filterConfig.tooltip ? <Tooltip text={filterConfig.tooltip} position="right">
                <LinkSimple size={14} weight="bold"/>
              </Tooltip> : <LinkSimple size={14} weight="bold"/>}
            </div>
          )}
          <TITLE_TYPO 
            style={{ 
              color: colors2.grey80,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              whiteSpace: 'normal',
              lineHeight: '1.2',
              minWidth: 0 // Allows text to shrink and show ellipsis
            }} 
            semibold
          >
            {title}
          </TITLE_TYPO>
          <div style={{ width: "500", background: colors2.grey5 }} onClick={(e) => e.stopPropagation()}>
          {debug && (
            <ReactJson
              title={title}
              src={filterConfig}
              collapsed={1}
              displayDataTypes={false}
              displayObjectSize={false}
              enableClipboard={false}
              name={false}
              collapseStringsAfterLength={60}
            />
          )}
          </div>
        </div>

        <div style={{
          display: "flex",
          gap: "0.6rem",
          alignItems: "center",
          flexShrink: 0 // Prevents right side from shrinking
        }}>
          {hasValue ? (
            <UI_BODY_BOLD_SM>{(lightboxConfig.comp === "DateRangeType" || isNumberRange) ? "1" : value.length}</UI_BODY_BOLD_SM>
          ) : null}
          <CaretRight size={16} color={colors2.grey40} />
        </div>

      </StyledFilterAccordionTitleWrapper>
      {/* Number Range Type: compact inline editor (dropdown + inputs + histogram button) */}
      {isNumberRange ? (
        <StyledSelectedValuesWrapper>
          <NumberRangeCompactInput
            value={value || {}}
            onChange={(v) => onChange(id, v)}
            min={lightboxConfig?.props?.min ?? 0}
            max={lightboxConfig?.props?.max ?? 100}
            // While bounds load (or the fetch failed) min/max are the 0–100
            // placeholder; disable editing so typed values aren't clamped to it.
            disabled={!!lightboxConfig?.props?.loading}
            onHistogramClick={onToggle}
          />
        </StyledSelectedValuesWrapper>
      ) : (lightboxConfig.comp === "DateRangeType" && value.length > 0) ? (
        <StyledSelectedValuesWrapper>
          <TagClearV2
            grey
            id={value}
            display={`${readableDate(value[0])} - ${readableDate(value[1])}`}
            size="XS"
            onClick={(e) => {
              // Prevent click from bubbling to parent accordion header, which would open the lightbox
              e.stopPropagation();
              onChange(
                id,
                value.filter((d) => value !== value)
              );
            }}
          />
        </StyledSelectedValuesWrapper>
      ) : value?.length > 0 && (
        <StyledSelectedValuesWrapper>
          {value.map((v) => (
            <TagClearV2
              key={v.value}
              grey
              id={v.value}
              display={v.display}
              size="XS"
              fill="outline"
              onClick={(e) => {
                // Prevent click from bubbling to parent accordion header, which would open the lightbox
                e.stopPropagation();
                onChange(
                  id,
                  value.filter((d) => d.value !== v.value)
                );
              }}
            />
          ))}
        </StyledSelectedValuesWrapper>
      )}
    </StyledFilterAccordionHeader>
  );
};
